/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React, {memo} from 'react';
import {translate} from '@ion/core/src/locale/locale';
import CardItemRow from '@ion/dls/src/layout/CardItemRow';
import {getFormattedDate} from '@ion/dls/src/utils/ComponentUtils';

export interface SpreaderAccordionMessageTimeProps {
  messageTime: string;
}

/**
 * A simple component used for displaying the time of a message for spreaders.
 *
 * ```typescript
 *
 * import SpreaderAccordionMessageTime from 'ion-suite/src/manufacturer/SpreaderAccordionMessageTime';
 *
 * <SpreaderAccordionMessageTime messageTime={messageTime} />
 *
 * ```
 *
 * @param messageTime The time of the message.
 *
 */
const SpreaderAccordionMessageTime = ({messageTime}: SpreaderAccordionMessageTimeProps) => {
  if (messageTime) {
    return (
      <CardItemRow label={translate('tracking:spreader.receivedTime')}
        value={getFormattedDate(messageTime)}
        isCenterAligned={false}
        isBottomMargin={false}
        isTextRightAligned
        isCondensedVariant
        isLabelColon />
    );
  }
  return null;
};

export default memo(SpreaderAccordionMessageTime);
